import React, { useState, useEffect } from 'react';
import { FacebookShareButton, TwitterShareButton } from 'next-share';

import { ISeoMetadataFields } from '../../../types/contentful';

import { BlockContainer, Layout, Column } from '../Layout';
import { FacebookIcon, TwitterIcon } from '../SocialIcons';
import { LinkIcon } from '../SocialIcons/LinkIcon';
import { trackWithFingerprint } from 'src/utils/trackWithFingerprint';

export function ShareButtons({
  seoTitle,
  seoMetaDescription
}: ISeoMetadataFields) {
  const [currentPage, setCurrentPage] = useState('');

  useEffect(() => {
    if (location) {
      const currentUrl =
        location.protocol + '//' + location.host + location.pathname;
      setCurrentPage(currentUrl);
    }
  }, []);

  return (
    <BlockContainer
      marginTop={{ 0: 'ml', tablet: 'l' }}
      marginBottom={{ 0: 'm', tablet: 'ml' }}
    >
      <Layout gutter={{ 0: 'ml', tablet: 'm', desktop: 'xl' }}>
        <Column size={{ 0: 10, tablet: 8 }}>
          <FacebookShareButton
            url={currentPage}
            quote={seoMetaDescription!}
            onClick={() => {
              trackWithFingerprint('CTA Clicked', {
                blog_share_type: 'Facebook',
                module: 'blog_share_icon'
              });
            }}
          >
            <FacebookIcon size="large" />
          </FacebookShareButton>
          <TwitterShareButton
            url={currentPage}
            title={seoTitle!}
            onClick={() => {
              trackWithFingerprint('CTA Clicked', {
                blog_share_type: 'Twitter',
                module: 'blog_share_icon'
              });
            }}
          >
            <TwitterIcon size="large" />
          </TwitterShareButton>
          <LinkIcon />
        </Column>
      </Layout>
    </BlockContainer>
  );
}
